export const INTERVENTION_TYPE_INTERVENTION = 'Intervention';
export const INTERVENTION_TYPE_AFFICHAGE = 'Affichage';
export const INTERVENTION_TYPE_NON_DEFINI = 'NonDefini';

export const TYPE_INTERVENTION = [
  { key: INTERVENTION_TYPE_NON_DEFINI, libelle: 'editionIntervention.interventionType.nonDefini' },
  { key: INTERVENTION_TYPE_AFFICHAGE, libelle: 'editionIntervention.interventionType.affichage' },
  { key: INTERVENTION_TYPE_INTERVENTION, libelle: 'editionIntervention.interventionType.intervention' },
];

export const TYPE_INTERVENTION_WITHOUT_NON_DEFINI = [
  { key: INTERVENTION_TYPE_AFFICHAGE, libelle: 'editionIntervention.interventionType.affichage' },
  { key: INTERVENTION_TYPE_INTERVENTION, libelle: 'editionIntervention.interventionType.intervention' },
];

export const ETAT_VALIDE = 'Valide';
export const ETAT_NOUVEAU = 'Nouveau';
export const ETAT_TRAITE = 'Traite';
export const ETAT_REFUSE = 'Refuse';

export const ETAT_DEMANDE_INTERVENTION = [
  {
    key: ETAT_NOUVEAU, libelle: 'editionIntervention.etatIntervention.nouveau', icon: 'checkbox-blank-circle', type: 'is-primary',
  },
  {
    key: ETAT_VALIDE, libelle: 'editionIntervention.etatIntervention.valide', icon: 'check-circle', type: 'is-success',
  },
  {
    key: ETAT_TRAITE, libelle: 'editionIntervention.etatIntervention.traite', icon: 'checkbox-blank-circle', type: 'is-success',
  },
  {
    key: ETAT_REFUSE, libelle: 'editionIntervention.etatIntervention.refuse', icon: 'checkbox-blank-circle', type: 'is-danger',
  },
];

export const SOURCE_TELEPHONE = 'Telephone';
export const SOURCE_MAIL = 'Mail';
export const SOURCE_AUTRE = 'Autre';
export const SOURCE_AFFIXE_MOBILE = 'AffixeMobile';
export const SOURCE_VENTE = 'Vente';

export const SOURCE_INTERVENTION = [
  { key: SOURCE_TELEPHONE, libelle: 'editionIntervention.interventionSource.telephone' },
  { key: SOURCE_MAIL, libelle: 'editionIntervention.interventionSource.mail' },
  { key: SOURCE_AUTRE, libelle: 'editionIntervention.interventionSource.autre' },
  { key: SOURCE_AFFIXE_MOBILE, libelle: 'editionIntervention.interventionSource.affixeMobile' },
  { key: SOURCE_VENTE, libelle: 'editionIntervention.interventionSource.vente' },
];

export const ACTION_FUSION = 'FusionDemandeIntervention';
